export default __webpack_public_path__ + "static/realWorldImg2-24b2fbd507e7e3163d7af4633e729bd0.png";